import type { ColumnDef } from '@tanstack/react-table'
import type CrmFundraisingDonationNature from '@/types/serializers/CrmFundraisingDonationNature'
import { DonationNatureActions } from './DonationNatureActions'

export const donationNatureColumns: ColumnDef<CrmFundraisingDonationNature, unknown>[] = [
  {
    accessorKey: 'name',
    header: 'Nom',
    cell: ({ row }) => (
      <span className="font-medium">{row.original.name}</span>
    ),
  },
  {
    accessorKey: 'code',
    header: 'Code',
    cell: ({ row }) => (
      <span className="font-mono text-xs">
        {row.original.code ?? '-'}
      </span>
    ),
  },
  {
    accessorKey: 'position',
    header: 'Position',
    cell: ({ row }) => row.original.position,
  },
  {
    id: 'actions',
    header: '',
    cell: ({ row }) => <DonationNatureActions nature={row.original} />,
  },
]
